import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-groups-placeholder',
  standalone: false,
  templateUrl: './groups-placeholder.component.html',
  styleUrl: './groups-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupsPlaceholderComponent {
  private readonly modalService = inject(NzModalService);

  // nzCloseOnNavigation reacts only to history back/forward, so a routerLink leaves the host modal open
  protected closeModals(): void {
    this.modalService.closeAll();
  }
}
